module.exports = __webpack_public_path__ + "img/casa_estuche hermano gitano.7ee3c7fd.webp";